import './soundcloudPlayer.scss';
import { useIntersectionObserver } from '@rocketmakers/armstrong';
import * as React from 'react';
export const SoundcloudPlayer = ({ id }) => {
    const [loaded, setLoaded] = React.useState(true);
    const ref = React.useRef(null);
    useIntersectionObserver(ref, (isIntersecting, entries, io) => {
        if (isIntersecting) {
            io.disconnect();
            setLoaded(true);
        }
    }, { rootMargin: '200px' });
    return (<div className="soundcloud-wrapper" ref={ref}>
      {loaded && (<iframe width="100%" height="166" scrolling="no" 
    // frameborder="no"
    allow="autoplay" src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${id}&color=%2300a387&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`}/>)}
    </div>);
};
